import { z } from 'zod';

export const DependencyStatusSchema = z.object({
  status: z.enum(['up', 'down', 'not_configured']),
  latencyMs: z.number().nonnegative().optional(),
});

export const HealthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
  timestamp: z.string().datetime(),
  dependencies: z.object({
    redis: DependencyStatusSchema,
    database: DependencyStatusSchema,
  }),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
